const EncodeDecodeType = {
    DEFAULT: "DEFAULT",
    CHATBOT: "CHATBOT",
    ONLINE: "ONLINE",
    URL_FORM_ENCODED: "URL_FORM_ENCODED"
}

export default EncodeDecodeType;


// WEBPACK FOOTER //
// ./src/enums/EncodeDecodeType.js